module.exports = __webpack_public_path__ + "img/error-no-classified.9f4d979e.svg";